import React from 'react';
import {
  addPathToList,
  Configure_screen_number,
  Enable_additional_instructions,
  Enter_number,
  getSubCategoryId, Number_of_installments,
} from '../utils/DictionaryManagementUtils';
import FullPagePanel from '../components/PanelsComponents/General/FullPagePanel';
import SwitcherPanel from '../components/PanelsComponents/Buttons/SwitcherPanel';
import { arrangeScreenInJson } from '../screens/ScreensOrdering';

//= ========================================================================
const Panel_J02_LoanNumberInstallments = ({
  globJSON,
  selectedScreen,
  onConfigChanged,
  onGotoEdit,
  onStepPressed,
  language,
}) => {
  const editTextList = [
    'enter_number_installments',
    'next',
  ];
  const myScreen = globJSON.screens[selectedScreen];
  const subCategoryId = getSubCategoryId(myScreen);
  const { number } = globJSON.configurations.services[subCategoryId];
  const onValueChanged = (key, value) => {
    number[key] = value;
    arrangeScreenInJson(globJSON, onConfigChanged);
  };

  return (
    <FullPagePanel
      globJSON={globJSON}
      onConfigChanged={onConfigChanged}
      selectedScreen={selectedScreen}
      onStepPressed={onStepPressed}
      onGotoEdit={onGotoEdit}
      panelHeadline={Number_of_installments}
      panelSubHeadline={Enter_number}
      editTextList={addPathToList(editTextList, `configurations/services/${subCategoryId}/number/`)}
      tooltipsTitles={globJSON.configurations.services[subCategoryId].screens_ordering}
      paragraph={Configure_screen_number}
      language={language}
    >
      <SwitcherPanel
        text={Enable_additional_instructions}
        value={number.enable_additional_instruction}
        onValueChanged={(value) => {
          onValueChanged('enable_additional_instruction', value);
        }}
      />
    </FullPagePanel>
  );
};

export default Panel_J02_LoanNumberInstallments;
